import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import { GET_PAYMENT_TRANSACTION_DETAILS, GET_PAYMENT_TYPE } from "../constants";

export const payPayment = (data, navigate) => async (dispatch) => {
  try {
    const payload = { ...data, wallet: data?.wallet || 0 };
    const response = await axiosInstance.post("payment", payload);
    if (response?.data?.status) {
      dispatch({ type: GET_PAYMENT_TRANSACTION_DETAILS, paymenttransactiondetails: response?.data });
      return response;
    }
    return response;
  } catch (err) {
  }
};


export const initiatePayment = (data) => async (dispatch) => {
  try {
    const payload = { ...data, wallet: data?.wallet || 0 };
    const response = await axiosInstance.post("payment", payload);
    if (response?.data?.status) {
      dispatch({ type: GET_PAYMENT_TRANSACTION_DETAILS, paymenttransactiondetails: response?.data?.response });
      urtoast(response?.data?.response?.message, 1);
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
  }
};

export const getPaymentType = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("payment/type");
    if (response?.data?.status) {
      dispatch({ type: GET_PAYMENT_TYPE, paymenttypelist: response?.data?.response });
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
    return response;
  } catch (err) {
  }
};


